import React from 'react';

function Result() {
    return (
        <p>
            Your Message has been successfully sent
        </p>
    )
}

export default Result
